import * as yup from 'yup';
import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

const config = {
    name: 'eventReservations',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' },
        { type: 'request', name: 'getEvents' },
        { type: 'request', name: 'getPaymentTypes' }
    ],
    endpoints: {
        eventReservations: '/event-reservations',
        eventReservation: '/event-reservations/[id]',
        eventReservationStatus: '/event-reservations/[id]/status',
        events: '/events',
        paymentTypes: '/payment-types'
    },
    defaults: {
        createEventReservation: {
            eventId: '',
            name: '',
            email: '',
            phone: '',
            status: 'waiting',
            paymentStatus: 'unpaid',
            paymentTypeId: null,
            amount: '',
            notes: ''
        }
    },
    validations: {
        eventId: yup.number().required('Evenimentul este obligatoriu'),
        name: yup.string().required('Numele este obligatoriu'),
        email: yup.string().email('Email invalid').required('Email-ul este obligatoriu'),
        phone: yup.string().required('Telefonul este obligatoriu')
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
